import React, { useCallback, useMemo } from 'react';
import { Box,Controller,FormFieldsContainer, OptionKey, RawButton,Text, useFormContext } from '@common-fe/common-fe';
import _ from 'lodash';

import { IPermission, IRoleSetup } from '../../role.types';

import PermissionToggleField from './PermissionToggleField';


interface Props {
  id?:string;
  options: IPermission[];
  isEditMode?: boolean;
  isDisabled?: boolean;
}

const PermissionToggleBlock: React.FC<Props> = ({isDisabled, id, isEditMode,options }) => {
  const {
    control,
  } = useFormContext<IRoleSetup>();
  const ids = useMemo(() => {
    return options.map((item) => item.key);
  }, [options]);
  const handleSelectAll = useCallback((values: OptionKey[], callback: (newValues: OptionKey[]) => void) => () => {
    const difference = _.difference(ids,values);
    if(difference.length) {
      callback([...values, ...difference]);
    } else {
      const filteredList = values.filter((item) => !ids.includes(item as string));
      callback(filteredList);
    }
  }, [ids]);
  return (
    <Box round="container1Round" background="canvas" pad="l" border={{ size: 'small', color: 'border1' }}>
      <Box direction='row'>
        <Controller
          name="permissions"
          control={control}
          render={({ field }) => (
            <RawButton disabled={isDisabled} data-testid={`role_select-all-permission_${id}`} onClick={handleSelectAll(field.value, field.onChange)}>
              <Text color="textAccent" weight={400}>Select All</Text>
            </RawButton>
          )}
        />
      </Box>
      <FormFieldsContainer>
        {options.map((option) => (
          <Box key={option.key} pad={{top: 'm'}}>
            <PermissionToggleField isDisabled={isDisabled} isEditMode={isEditMode} {...option} key={option.key} group={option.key} />
          </Box>
        ))}

      </FormFieldsContainer>

    </Box>
  );
};

export default PermissionToggleBlock;